import api from '../../api'

import {
    CREATE_NEW_CONTACT,
    SET_CONTACT,
    RESET_CONTACT,
    SET_CONTACT_DATE_CREATED,
    SET_CONTACT_DATE_MODIFIED,
    SET_CONTACT_DIRTYNESS,
    SET_CONTACT_EMAILADDRESSES,
    SET_CONTACT_ID,
    SET_CONTACT_MAIN_EMAIL,
    SET_CONTACT_NAME,
    SET_CONTACT_ORGANIZATION,
    SET_CONTACT_PATH,
    SET_CONTACT_PERSON_TYPE,
    SET_CONTACT_REPRESENTATIVE,
    SET_CONTACT_REPRESENTATIVE_TIN,
    SET_CONTACT_SURNAMES,
    SET_CONTACT_TELEPHONENUMBERS,
    SET_CONTACT_TIN,
    SET_CONTACT_TITLE,
    SET_CONTACT_COMPLETE_NAME,
    SET_CONTACT_COMPLETE_FISCAL_ADDRESS,
    SET_CONTACT_MAIN_TELEPHONENUMBER,
    UPDATE_CONTACT
} from '../../constants'

const default_state = {
    date_created: null,
    date_modified: null,
    dirty: false,
    id: null,
    main_email: null,
    name: null,
    organization: null,
    path: null,
    person_type: null,
    representative: null,
    representative_tin: null,
    surnames: null,
    tin: null,
    title: null,
    complete_name: null,
    complete_fiscal_address: null,
    main_telephonenumber: null,



}
const state = default_state

const actions = {
    CREATE_NEW_CONTACT: ({state, commit, rootState}, data) => {
        return new Promise((resolve, reject) => {

            // cal fer un RESET CONTACT aquí??? estava així, l'hem tret al treballr la cració de contactes dinpamica des de pressupost
            // commit(RESET_CONTACT)
            // resposta: sí, si es crea des de lapartat de contactes, no si es fa des de un import des de pressupost per exemple, per tant:

            if(data.creating_from_main){
                commit(RESET_CONTACT)
            }

            api.create({path: data.path})
                .then((res) => {
                    let new_created_key = res.key
                    commit(SET_CONTACT_ID, res.key)
                    commit(SET_CONTACT_DATE_CREATED, res.date_created)
                    commit(SET_CONTACT_DATE_MODIFIED, res.date_modified)
                    commit(SET_CONTACT_PATH, res.path)
                    api.set_value({
                        value: new_created_key ,
                        path: data.path + '/' + new_created_key  + '/' + 'id',
                        save_timestamp: false
                    }).then(res => resolve({key: new_created_key}))
                })
        })
    },
    DELETE_CONTACT: ({state, commit, rootState}, data) => {

        console.log('path check: ' + data.path)
        api.delete({key: data.key, path: data.path})
            .then((res) => {
                commit(RESET_CONTACT)

                api.delete({key: data.key, path: 'contact_addresses' + '/' + data.key})
                    .then((res) => {
                    })

            })
    },
    RESET_CONTACT: ({state, commit, rootState}) => {
        commit(RESET_CONTACT)
    },
    SET_CONTACT: ({state, commit, rootState}, data) => {

        console.log('set_contact data:')
        console.log(data)
        return api.get({path: data.path})
            .then((res) => {
                console.log(res)
                commit(SET_CONTACT, res)
            })

    },
    SET_CONTACT_DATE_CREATED: ({state, commit, rootState}, data) => {
        commit(SET_CONTACT_DATE_CREATED, data)
    },
    SET_CONTACT_DATE_MODIFIED: ({state, commit, rootState}, data) => {
        commit(SET_CONTACT_DATE_MODIFIED, data)
    },
    SET_CONTACT_ID: ({state, commit, rootState}, data) => {
        commit(SET_CONTACT_ID, data)
    },
    SET_CONTACT_EMAILADDRESSES: ({state, commit, rootState}, data) => {
        commit(SET_CONTACT_EMAILADDRESSES, data)
    },
    SET_CONTACT_MAIN_EMAIL: ({state, commit, rootState}, data) => {
        commit(SET_CONTACT_MAIN_EMAIL, data)
    },
    SET_CONTACT_NAME: ({state, commit, rootState}, name) => {
        commit(SET_CONTACT_NAME, name)
    },
    SET_CONTACT_ORGANIZATION: ({state, commit, rootState}, name) => {
        commit(SET_CONTACT_ORGANIZATION, name)
    },
    SET_CONTACT_PATH: ({state, commit, rootState}, data) => {
        commit(SET_CONTACT_PATH, data)
    },
    SET_CONTACT_PERSON_TYPE: ({state, commit, rootState}, person_type) => {
        commit(SET_CONTACT_PERSON_TYPE, person_type)
    },
    SET_CONTACT_REPRESENTATIVE: ({state, commit, rootState}, name) => {
        commit(SET_CONTACT_REPRESENTATIVE, name)
    },
    SET_CONTACT_REPRESENTATIVE_TIN: ({state, commit, rootState}, name) => {
        commit(SET_CONTACT_REPRESENTATIVE_TIN, name)
    },
    SET_CONTACT_SURNAMES: ({state, commit, rootState}, surnames) => {
        commit(SET_CONTACT_SURNAMES, surnames)
    },
    SET_CONTACT_TELEPHONENUMBERS: ({state, commit, rootState}, telephonenumbers) => {
        commit(SET_CONTACT_TELEPHONENUMBERS, telephonenumbers)
    },
    SET_CONTACT_TIN: ({state, commit, rootState}, tin) => {
        commit(SET_CONTACT_TIN, tin)
    },
    SET_CONTACT_TITLE: ({state, commit, rootState}, title) => {
        commit(SET_CONTACT_TITLE, title)
    },
    SET_CONTACT_COMPLETE_NAME: ({state, commit, rootState}, data) => {
        commit(SET_CONTACT_COMPLETE_NAME, data)
    },
    SET_CONTACT_COMPLETE_FISCAL_ADDRESS: ({state, commit, rootState}, data) => {
        commit(SET_CONTACT_COMPLETE_FISCAL_ADDRESS, data)
    },
    SET_CONTACT_MAIN_TELEPHONENUMBER: ({state, commit, rootState}, data) => {
        commit(SET_CONTACT_MAIN_TELEPHONENUMBER, data)
    },
    UPDATE_CONTACT: ({state, commit, rootState}, data) => {
        api.update({object: data.object, path: data.path, save_timestamp: true})
            .then((res) => {
                commit(SET_CONTACT_DATE_MODIFIED, res.date_modified)
                commit(SET_CONTACT_DIRTYNESS, false)

            })
    }
}

const mutations = {
    [RESET_CONTACT] (state) {
        state.date_created = null
        state.date_modified = null
        state.id = null
        state.main_email = null
        state.name = null
        state.organization = null
        state.path = null
        state.person_type = null
        state.representative = null
        state.representative_tin = null
        state.surnames = null
        state.tin = null
        state.title = null
        state.dirty = false
        state.complete_name = null
        state.complete_fiscal_address = null
        state.main_telephonenumber = null


    },
    [SET_CONTACT] (state, data) {
        // console.log('mutations SET_CONTACT data: ')
        //  console.log(data)
        state.date_created = check_undefined(data.date_created)
        state.date_modified = check_undefined(data.date_modified)
        state.id = check_undefined(data.id)
        state.main_email = check_undefined(data.main_email)
        state.name = check_undefined(data.name)
        state.organization = check_undefined(data.organization)
        state.path = check_undefined(data.path)
        state.person_type = check_undefined(data.person_type)
        state.representative = check_undefined(data.representative)
        state.representative_tin = check_undefined(data.representative_tin)
        state.surnames = check_undefined(data.surnames)
        state.tin = check_undefined(data.tin)
        state.title = check_undefined(data.title)
        state.dirty = false
        state.complete_name = check_undefined(data.complete_name)
        state.complete_fiscal_address = check_undefined(data.complete_fiscal_address)
        state.main_telephonenumber = check_undefined(data.main_telephonenumber)


    },
    [SET_CONTACT_DATE_CREATED] (state, data) {
        state.date_created = data
        state.dirty = true
    },
    [SET_CONTACT_DATE_MODIFIED] (state, data) {
        state.date_modified = data
        state.dirty = true
    },
    [SET_CONTACT_DIRTYNESS] (state, boolean) {
        state.dirty = boolean
    },
    [SET_CONTACT_ID] (state, data) {
        state.id = data
        state.dirty = true
    },
    [SET_CONTACT_EMAILADDRESSES] (state, emailaddresses) {
        state.emailaddresses = emailaddresses
        state.dirty = true
    },
    [SET_CONTACT_MAIN_EMAIL] (state, data) {
        state.main_email = data
        state.dirty = true
    },
    [SET_CONTACT_NAME] (state, name) {
        state.name = name
        state.dirty = true
    },
    [SET_CONTACT_ORGANIZATION] (state, data) {
        state.organization = data
        state.dirty = true
    },
    [SET_CONTACT_PATH] (state, data) {
        state.path = data
        state.dirty = true
    },
    [SET_CONTACT_PERSON_TYPE] (state, person_type) {
        state.person_type = person_type
        state.dirty = true
    },
    [SET_CONTACT_REPRESENTATIVE] (state, data) {
        state.representative = data
        state.dirty = true
    },
    [SET_CONTACT_REPRESENTATIVE_TIN] (state, data) {
        state.representative_tin = data
        state.dirty = true
    },
    [SET_CONTACT_SURNAMES] (state, surnames) {
        state.surnames = surnames
        state.dirty = true
    },
    [SET_CONTACT_TELEPHONENUMBERS] (state, telephonenumbers) {
        state.telephonenumbers = telephonenumbers
        state.dirty = true
    },
    [SET_CONTACT_TIN] (state, tin) {
        state.tin = tin
        state.dirty = true
    },
    [SET_CONTACT_TITLE] (state, title) {
        state.title = title
        state.dirty = true
    },
    [SET_CONTACT_COMPLETE_NAME] (state, data) {
        state.complete_name = data
        state.dirty = true
    },
    [SET_CONTACT_COMPLETE_FISCAL_ADDRESS] (state, data) {
        state.complete_fiscal_address = data
        state.dirty = true
    },
    [SET_CONTACT_MAIN_TELEPHONENUMBER] (state, data) {
        state.main_telephonenumber = data
        state.dirty = true
    },
}

function check_undefined (myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar
    } else {
        return null
    }
}

const getters = {

    contact: state => {
        return state
    }
}

export default {
    state,
    actions,
    mutations,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/contact/contact.js